export default __webpack_public_path__ + "static/media/icon_clipboard_outline.f5eb562d.svg";